import { render, staticRenderFns } from "./CredentialsModal.vue?vue&type=template&id=3a64fd4b&scoped=true"
import script from "./CredentialsModal.vue?vue&type=script&lang=js"
export * from "./CredentialsModal.vue?vue&type=script&lang=js"
import style0 from "./CredentialsModal.vue?vue&type=style&index=0&id=3a64fd4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a64fd4b",
  null
  
)

export default component.exports